import PokerTablePokerBase from "./poker_table_poker_base";
import { Card } from "../../../q2/module/table/q2_card_common";

const { ccclass, property, menu } = cc._decorator;

export enum VerticalDirection{
    BottomToTop = 0,
    CenterToMargin = 1,
    TopToBottom = 2,
}

export enum HorizontalDirection{
    LeftToRight = 0,
    CenterToMargin  = 1,
    RightToLeft = 2,
}

// enum AlignType{    
//     Center = 1,
//     FollowDirection = 2,
// }


export enum StartAxis{
    Horizontal = 0,
    Vertical = 1,
}

export enum HorizontalPriority{
    Left = 0,
    Right = 1,
}

export enum VerticalPriority{
    Top = 0,
    Bottom = 1,
}

@ccclass
@menu("custom/PokerTableSeatPokers")
export default class PokerTableSeatPokers extends cc.Component{
    @property(PokerTablePokerBase)
    prefabPoker: PokerTablePokerBase = null

    @property(cc.Node)
    nodePokersParent: cc.Node = null

    protected m_unUseedHandPokers: PokerTablePokerBase[] = []    

    @property({type: cc.Enum(StartAxis)})
    startAxis: StartAxis = StartAxis.Horizontal

    @property({type: cc.Enum(HorizontalDirection)})
    horizontalDirection: HorizontalDirection = HorizontalDirection.CenterToMargin

    @property({type: cc.Enum(VerticalDirection)})
    verticalDirection: VerticalDirection = VerticalDirection.CenterToMargin

    @property({type: cc.Enum(HorizontalPriority)})
    horizontalPriority: HorizontalPriority = HorizontalPriority.Right

    @property({type: cc.Enum(VerticalPriority)})
    verticalPriority: VerticalPriority = VerticalPriority.Bottom

    @property(cc.Boolean)
    followHorizontalDirection: boolean = true

    @property(cc.Boolean)
    followVerticalDirection: boolean = true


    @property(cc.Float)
    offsetX: number = 0

    @property(cc.Float)
    offsetY: number = 0

    @property(cc.Float)
    intervalX: number = 0

    @property(cc.Float)
    intervalY: number = 0

    @property(cc.Integer)
    maxColCount: number = 0

    @property(cc.Integer)
    maxRowCount: number = 0


    get uid(){
        return this.m_uid
    }
    set uid(val){
        this.m_uid = val
        for (let index = 0; index < this.m_unUseedHandPokers.length; index++) {
            const element = this.m_unUseedHandPokers[index];
            element.uid = val
        }
        for (let index = 0; index < this.pokers.length; index++) {
            const element = this.pokers[index];
            element.uid = val
        }
    }
    protected m_uid: number = 0

    protected pokers: PokerTablePokerBase[] = []

    protected m_customGetSpriteFrameKeyFunc: Function = null

    reset(){
        this.showPokers(false)
    }

    setCustomGetSpriteFrameKeyByCodeFunc(func: Function, refreshSpriteNow?: boolean){
        this.m_customGetSpriteFrameKeyFunc = func
        if(refreshSpriteNow){
            for (let i = 0; i < this.pokers.length; i++) {
                const poker = this.pokers[i];
                poker.setCustomGetSpriteFrameKeyByCodeFunc(func, refreshSpriteNow)
            }            
        }
    }

    protected genPoker(code: number, params?: any){
        let poker = this.shiftUnUseedPoker(this.m_unUseedHandPokers)
        if(poker == null){
            let node = this.instantiateObj(this.prefabPoker.node, this.nodePokersParent)                                
            poker = node.getComponent(PokerTablePokerBase)
            poker.uid = this.uid
        }  
        poker.node.name = code + ""        
        poker.reset()
        poker.setCustomGetSpriteFrameKeyByCodeFunc(this.m_customGetSpriteFrameKeyFunc, false)
        poker.fillPoker(code, params)        
        return poker
    }

    protected recyclePoker(poker: PokerTablePokerBase){
        poker.node.parent = this.nodePokersParent
        poker.node.position = cc.v2(0, 0)
        poker.node.scale = 1  
        this.pushToUnUseedList(this.m_unUseedHandPokers, poker)
    }

    protected shiftUnUseedPoker(list: PokerTablePokerBase[]):PokerTablePokerBase{
        let poker = list.shift()
        return poker
    }

    protected pushToUnUseedList(list: PokerTablePokerBase[], poker: PokerTablePokerBase){
        list.push(poker)
    }

    private instantiateObj(prefabNode:cc.Node, parent:cc.Node):cc.Node{
        var node = cc.instantiate(prefabNode)
        node.parent = parent
        node.position = cc.v2(0, 0)
        node.scale = 1        
        return node
    }

    protected formatPokersLayout(pokerList: PokerTablePokerBase[]): cc.Vec2{
        let layoutData = this.calcLayoutPosAndPriority(pokerList.length)
        let dataList = layoutData.dataList
        for (let i = 0; i < pokerList.length; i++) {
            let poker = pokerList[i];          
            let data = dataList[i]  
            poker.node.position = data.pos
            poker.original_pos = data.pos
            poker.node.zIndex = data.priority 
        }
        return layoutData.centerPos
    }

    protected calcLayoutPosAndPriority(len: number){
        let dataList = []
        let self = this

        let maxColCount = this.maxColCount
        let maxRowCount = this.maxRowCount        
        let totalColCount = 1
        let totalRowCount = 1
        if(this.startAxis == StartAxis.Horizontal){
            if(len > maxColCount){
                totalColCount = maxColCount                
            }else{
                totalColCount = len
            }                
            totalRowCount = Math.ceil((len) / totalColCount)
        }else{
            if(len > maxRowCount){
                totalRowCount = maxRowCount
            }else{
                totalRowCount = len
            }           
            totalColCount = Math.ceil((len) / totalRowCount)
        }
        let minColCount = len % totalColCount
        let minRowCount = len % totalRowCount
        // cc.log(totalColCount, totalRowCount, minColCount, minRowCount)
        for (let i = 0; i < len; i++) {            
            let index = i  
            let offsetIndex = 0
            let leftCount = (len - 1) - index                                                                       
            let curTotalColCount = totalColCount
            let curTotalRowCount = totalRowCount

            let horizontalDirection = this.horizontalDirection
            let verticalDirection = this.verticalDirection
            let horizontalPriority = this.horizontalPriority
            let verticalPriority = this.verticalPriority
            if(!this.followHorizontalDirection){
                if(horizontalDirection == HorizontalDirection.LeftToRight){
                    horizontalDirection = HorizontalDirection.RightToLeft
                }else if(horizontalDirection == HorizontalDirection.RightToLeft){
                    horizontalDirection = HorizontalDirection.LeftToRight
                }
            }  
            if(!this.followVerticalDirection){
                if(verticalDirection == VerticalDirection.TopToBottom){
                    verticalDirection = VerticalDirection.BottomToTop
                }else if(verticalDirection == VerticalDirection.BottomToTop){
                    verticalDirection = VerticalDirection.TopToBottom
                }
            }
            if(this.startAxis == StartAxis.Horizontal){ 
                if(verticalDirection == VerticalDirection.BottomToTop){
                    if(minColCount > 0){
                        if(index >= minColCount){
                            offsetIndex = totalColCount - minColCount                                                 
                        }else{
                            if(horizontalDirection == HorizontalDirection.CenterToMargin){
                                curTotalColCount = minColCount
                            }else if(horizontalDirection == HorizontalDirection.RightToLeft){
                                offsetIndex = (totalColCount - minColCount)
                            }                           
                        }
                    }                    
                }else{

                }
                let tmpIndex = index + offsetIndex
                let tmpLeftCount = leftCount + offsetIndex
                if(horizontalDirection == HorizontalDirection.CenterToMargin){
                    if(tmpIndex % totalColCount + tmpLeftCount < minColCount){
                        curTotalColCount = minColCount
                    }
                }else if(horizontalDirection == HorizontalDirection.RightToLeft){
                    if(tmpIndex % totalColCount + tmpLeftCount < minColCount){
                        offsetIndex = (totalColCount - minColCount)
                    }
                }             
            }else{
                if(horizontalDirection == HorizontalDirection.RightToLeft){
                    if(minRowCount > 0){
                        if(index >= minRowCount){
                            offsetIndex = totalRowCount - minRowCount
                        }else{
                            if(verticalDirection == VerticalDirection.CenterToMargin){
                                curTotalRowCount = minRowCount
                            }else if(verticalDirection == VerticalDirection.BottomToTop){
                                offsetIndex = (totalRowCount - minRowCount)
                            }
                        }
                    }                    
                }else{

                }
                let tmpIndex = index + offsetIndex
                let tmpLeftCount = leftCount + offsetIndex
                if(verticalDirection == VerticalDirection.CenterToMargin){
                    if(tmpIndex % totalRowCount + tmpLeftCount < minRowCount){
                        curTotalRowCount = minRowCount
                    }
                }else if(verticalDirection == VerticalDirection.BottomToTop){
                    if(tmpIndex % totalRowCount + tmpLeftCount < minRowCount){
                        offsetIndex = (totalRowCount - minRowCount)
                    }
                } 
            }        
                                   
            let col = this.getCol(index, totalColCount, totalRowCount, offsetIndex)
            let row = this.getRow(index, totalColCount, totalRowCount, offsetIndex)
            let pos = this.calcPos(col, row, curTotalColCount, curTotalRowCount)            
            let priority = 0
            priority = this.calcHorizontalPriority(priority, col, totalColCount, totalRowCount)
            priority = this.calcVerticalPriority(priority, row, totalColCount, totalRowCount)
            dataList.push({pos: pos, col: col, row: row, priority: priority})
        }
        let col = (totalColCount - 1) * 0.5
        let row = (totalRowCount - 1) * 0.5
        let centerPos = this.calcPos(col, row, totalColCount, totalRowCount)
        return {dataList:dataList, centerPos: centerPos}
    }

    protected getCol(index: number, totalColCount: number, totalRowCount: number, offsetIndex: number): number{
        let startAxis = this.startAxis
        let horizontalDirection = this.horizontalDirection
        let verticalDirection = this.verticalDirection
        let horizontalPriority = this.horizontalPriority
        let verticalPriority = this.verticalPriority
        let col = 0
        if(startAxis == StartAxis.Horizontal){
            col = (index + offsetIndex) % totalColCount                       
        }else{
            col = Math.floor((index + offsetIndex) / totalRowCount)           
        }
        
        return col
    }

    protected getRow(index: number, totalColCount: number, totalRowCount: number, offsetIndex: number): number{
        let row = 0
        let startAxis = this.startAxis
        let horizontalDirection = this.horizontalDirection
        let verticalDirection = this.verticalDirection
        let horizontalPriority = this.horizontalPriority
        let verticalPriority = this.verticalPriority
        if(startAxis == StartAxis.Horizontal){
            row = Math.floor((index + offsetIndex) / totalColCount)       
        }else{
            row = (index + offsetIndex) % totalRowCount                      
        }
        return row
    }

    protected calcHorizontalPriority(priority: number, col: number, totalColCount: number, totalRowCount: number): number{
        let startAxis = this.startAxis
        let horizontalDirection = this.horizontalDirection
        let verticalDirection = this.verticalDirection
        let horizontalPriority = this.horizontalPriority
        let verticalPriority = this.verticalPriority
        if(startAxis == StartAxis.Horizontal){
            if(horizontalPriority == HorizontalPriority.Left){                   
                return priority + (totalColCount - col)
            }else{
                return priority + col
            }
        }else{
            if(horizontalPriority == HorizontalPriority.Left){
                return priority + (totalColCount - col) * totalRowCount
            }else{
                return priority + col * totalRowCount
            } 
        }                 
    }

    protected calcVerticalPriority(priority: number, row: number, totalColCount: number, totalRowCount: number): number{
        let startAxis = this.startAxis
        let horizontalDirection = this.horizontalDirection
        let verticalDirection = this.verticalDirection
        let horizontalPriority = this.horizontalPriority
        let verticalPriority = this.verticalPriority
        if(startAxis == StartAxis.Horizontal){
            if(verticalPriority == VerticalPriority.Top){
                return priority + (totalColCount - row) * totalColCount
            }else{                                
                return priority + row * totalColCount
            }   
        }else{
            if(verticalPriority == VerticalPriority.Top){
                return priority + (totalColCount - row)
            }else{                
                return priority + row
            }   
        }                 
    }

    protected getOffsetX(totalColCount: number, totalRowCount: number): number{
        return this.offsetX
    }

    protected getOffsetY(totalColCount: number, totalRowCount: number): number{
        return this.offsetY
    }

    protected getIntervalX(totalColCount: number, totalRowCount: number): number{
        return this.intervalX
    }

    protected getIntervalY(totalColCount: number, totalRowCount: number): number{
        return this.intervalY
    }

    protected calcPos(col: number, row: number, totalColCount: number, totalRowCount: number): cc.Vec2{           
        //最上面为第0行，最左边为第0列
        let centerCol = ((totalColCount - 1) * 0.5)
        let centerRow = ((totalRowCount - 1) * 0.5)
        let pos = cc.v2(0, 0)
        let intervalX = this.getIntervalX(totalColCount, totalRowCount)
        pos.x = intervalX * col
        if(this.horizontalDirection == HorizontalDirection.CenterToMargin){
            pos.x = intervalX * (col - centerCol)
        }else if(this.horizontalDirection == HorizontalDirection.LeftToRight){
            pos.x = intervalX * col
        }else if(this.horizontalDirection == HorizontalDirection.RightToLeft){
            pos.x = intervalX * (col - (totalColCount - 1))
        }
        pos.x += this.getOffsetX(totalColCount, totalRowCount)

        let intervalY = this.getIntervalY(totalColCount, totalRowCount)
        pos.y = intervalY * row
        if(this.verticalDirection == VerticalDirection.CenterToMargin){
            pos.y = intervalY * (centerRow - row)
        }else if(this.verticalDirection == VerticalDirection.TopToBottom){
            pos.y = intervalY * (-row)
        }else if(this.verticalDirection == VerticalDirection.BottomToTop){
            pos.y = intervalY * ((totalRowCount - 1) - row)
        }
        pos.y += this.getOffsetY(totalColCount, totalRowCount)
        return pos
    }

    genPokerList(codeList: number[], append: boolean, show?: boolean, showFace?: boolean): PokerTablePokerBase[]{
        if(!append){
            this.removeAllPokers()
        }
        let list = []
        for (let index = 0; index < codeList.length; index++) {
            const code = codeList[index];
            let poker = this.genPoker(code)                
            this.pokers.push(poker)
            if(show){
                poker.show()
            }else{
                poker.hide()
            }
            if(showFace){
                poker.showFace(true)
            }else{
                poker.showFace(false)
            }            
            list.push(poker)
        }
        return list
    }

    removeAllPokers(pokers?){
        pokers = pokers || this.pokers
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            poker.hide()
            poker.node.stopAllActions()
            this.pushToUnUseedList(this.m_unUseedHandPokers, poker)
        }
        if(pokers == this.pokers){
            this.pokers = []
        }        
    }

    removePoker(poker: PokerTablePokerBase){
        for (let i = 0; i < this.pokers.length; i++) {
            const p = this.pokers[i];
            if(poker.id == p.id){                
                this.removePokerByIndex(i)
                return
            }
        }
    }

    removePokers(pokers: PokerTablePokerBase[]){
        for (let i = 0; i < pokers.length; i++) {
            const poker = pokers[i];
            this.removePoker(poker)
        }
    }

    removePokerByIndex(index: number){
        let poker = this.pokers[index]
        this.pokers.splice(index, 1)
        poker.hide()
        this.pushToUnUseedList(this.m_unUseedHandPokers, poker)
    }

    showPokers(show: boolean, codeList?: number[], params?: any){
        this.removeAllPokers()        
        if(show){
            let pokerList = this.genPokerList(codeList, false)
            for (let index = 0; index < pokerList.length; index++) {
                let poker = pokerList[index]    
                poker.show()
                let srcId = Card.codeToSrcId(poker.code)
                if(srcId == 0){
                    poker.node.opacity = 188
                }else{
                    poker.node.opacity = 255
                }
                if(params){
                    if(params.hidePoker){
                        poker.hide()
                    }
                }                         
                poker.showFace(true)                
            }
            let centerLocalPos = this.formatPokersLayout(pokerList)

            let worldPos = this.nodePokersParent.convertToWorldSpaceAR(centerLocalPos)
            return worldPos
        }
        return cc.Vec2.ZERO
    }
    
}
